import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "../lib/auth";
import { api } from "../lib/api";
import { BrandLogo } from "../components/common";
import { ImpersonationBanner } from "../lib/impersonate";
import WishlinkLogo from "../components/WishlinkLogo";

export default function BrandLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [brand, setBrand] = useState(user?.brand || null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/brand/campaigns");
        setBrand(data.brand);
      } catch (e) {
        console.error("[BrandLayout] failed to load brand info", e);
      }
    })();
  }, []);

  const handleLogout = () => { logout(); nav("/login", { replace: true }); };

  return (
    <div className="min-h-screen brand-no-image-interactions" style={{ background: "var(--bg-page)" }}>
      <ImpersonationBanner user={user} />
      <header
        className="border-b border-[var(--border-default)]"
        style={{ background: "linear-gradient(180deg, var(--bg-tint) 0%, var(--bg-page) 100%)" }}
        data-testid="brand-header"
      >
        <div className="max-w-[1400px] mx-auto px-10 h-24 flex items-center justify-between">
          <div className="flex items-center gap-5">
            {/* Wishlink wordmark + Kiwi sub-brand */}
            <div className="flex flex-col items-center pr-5 border-r border-[var(--border-default)]" data-testid="brand-header-wishlink">
              <WishlinkLogo
                className="h-9 w-auto max-w-[160px] object-contain flex-shrink-0"
                fallbackClassName="font-display text-2xl font-semibold tracking-tight text-[var(--brand)]"
              />
              <span className="mt-0.5 text-[10px] font-semibold tracking-[0.22em] uppercase text-[var(--brand)]" data-testid="kiwi-wordmark">Kiwi</span>
            </div>
            {/* Brand identity — logo + name only (no eyebrow). Slightly bigger so it
                reads as the brand's own identity inside Wishlink Kiwi. */}
            <div className="flex items-center gap-3">
              <div className="rounded-xl bg-white border border-[var(--border-default)] p-1">
                <BrandLogo name={brand?.name || "B"} logoUrl={brand?.logo_url} size={40} />
              </div>
              <div className="font-display text-xl font-semibold leading-tight">{brand?.name || "Brand"}</div>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <span className="text-sm text-[var(--text-secondary)]" data-testid="brand-user-email">{user?.email}</span>
            <button onClick={handleLogout} className="wl-btn-ghost inline-flex items-center gap-2" data-testid="brand-sign-out">
              <LogOut size={16} /> Sign out
            </button>
          </div>
        </div>
      </header>
      <div className="max-w-[1400px] mx-auto px-10 py-10">
        <Outlet />
      </div>
    </div>
  );
}
